import { LeadsTarget } from 'modules/leads/types';

import { createLeadsListReducer } from '../createLeadsListReducer';

import filters from './filters';

export default createLeadsListReducer(LeadsTarget.INTERVENTION, { filters });
